import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-solicitacao`

    return {
        paciente: {
            autocomplete(params) {
                return repository.post(`${baseUrl}/autocomplete-paciente`, params)
            }
        },
        cid: {
            autocomplete(params) {
                return repository.post(`${baseUrl}/autocomplete-cid`, params)
            }
        },
        ciap: {
            autocomplete(params) {
                return repository.post(`${baseUrl}/autocomplete-ciap`, params)
            }
        },
        index(params) {
            return repository.post(`${baseUrl}/index`, params)
        },
        list(params) {
            return repository.post(`${baseUrl}/list`, params)
        },
    }
}